import type { RouteRecordRaw } from 'vue-router';

export default [
    {
        path: '/threats/:id',
        name: 'threat.show',
        component: () => import('./pages/threats/Show.vue'),
        meta: {
            layout: 'app',
        },
    },
    {
        path: '/risks',
        name: 'risks.index',
        component: () => import('./pages/risks/Index.vue'),
        meta: {
            layout: 'app',
        },
    },
    {
        path: '/risks/product-category',
        name: 'risks.index-by-product-category',
        component: () => import('./pages/risks/IndexByCategory.vue'),
        props: {
            categoryType: 'ProductCategory',
        },
        meta: {
            layout: 'app',
        },
    },
    {
        path: '/risks/threat-category',
        name: 'risks.index-by-threat-category',
        component: () => import('./pages/risks/IndexByCategory.vue'),
        props: {
            categoryType: 'ThreatCategory',
        },
        meta: {
            layout: 'app',
        },
    },
    {
        path: '/risks/:id',
        name: 'risk.show',
        component: () => import('./pages/risks/Show.vue'),
        meta: {
            layout: 'app',
            navigation: {
                risks: {
                    name: 'risks.index',
                },
            },
        },
    },
    {
        path: '/question-predicates',
        name: 'question-predicates.index',
        component: () => import('./pages/questionPredicates/Index.vue'),
        meta: {
            layout: 'app',
        },
    },
] satisfies RouteRecordRaw[];
